"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var React = tslib_1.__importStar(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
exports.Input = function (props) {
    var _a = props.className, className = _a === void 0 ? "" : _a, label = props.label, maxlength = props.maxlength, placeholder = props.placeholder, value = props.value, onChange = props.onChange;
    var classNames = "gd-input-component " + className;
    return (React.createElement("div", { className: classNames },
        React.createElement("label", { className: "gd-label" }, label),
        React.createElement(sdk_ui_kit_1.Input, { hasError: false, maxlength: maxlength, placeholder: placeholder, value: value, onChange: 
            // as any, the value will indeed always be string
            // TODO improve typings of Input in ui-kit to have properly typed the onChange related to the input type
            onChange })));
};
//# sourceMappingURL=Input.js.map